import { createContext, useState, useEffect } from "react";
import Bugsnag from "@bugsnag/js";
import axiosInstance from "../axiosInstance";
import URL from "../urls";

export const SuperviseeProfileContext = createContext({
  isSupervisionMode: false,
  superviseeId: null,
  superviseeProfile: null,
});

function SuperviseeProfileProvider({
  superviseeId,
  isSupervisionMode,
  children,
}) {
  const [profile, setProfile] = useState(null);
  const value = {
    isSupervisionMode,
    superviseeId,
    superviseeProfile: profile,
  };
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axiosInstance.get(URL.getProviderDetails, {
          params: {
            provider_id: superviseeId,
          },
        });
        const fetchedProfile = res?.data?.data || null;
        setProfile(fetchedProfile);
      } catch (err) {
        Bugsnag.notify(err);
      }
    };
    fetchProfile();
  }, [superviseeId]);

  return (
    <SuperviseeProfileContext.Provider value={value}>
      {children}
    </SuperviseeProfileContext.Provider>
  );
}

export default SuperviseeProfileProvider;
